import { container } from '@k-mille/ui-components'
import Component from './input'

const intl = 'number'

export default container({
  intl,
})(Component)
